import { Action, Selector, State, StateContext } from '@ngxs/store';
import { Injectable } from '@angular/core';
import { PreventGoBack, ResetPreventGoBack } from '../actions/back-button.action';

export interface BackButtonStateModel {
    preventGoBack: boolean;
}

@State<BackButtonStateModel>({
    name: 'backButton',
    defaults: {
        preventGoBack: false,
    },
})
@Injectable()
export class BackButtonState {
    @Selector()
    public static getPreventGoBack(state: BackButtonStateModel): boolean {
        return state.preventGoBack;
    }

    @Action(PreventGoBack)
    public setPreventGoBack(ctx: StateContext<BackButtonStateModel>): void {
        ctx.patchState({
            preventGoBack: true,
        });
    }

    @Action(ResetPreventGoBack)
    public resetPreventGoBack(ctx: StateContext<BackButtonStateModel>): void {
        ctx.patchState({
            preventGoBack: false,
        });
    }
}
